import { ArrowBack, DownloadRounded, EditRounded, MoreVert } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import axios from 'axios';
import _, { isEmpty, size } from 'lodash';
import React, { Component } from 'react';
import SwipeableTabs from '../../../../container/MUI/SwipeableTabs';
import Dialog from '../../../common/Dialog';
import Sessions from '../Forms/Sessions';
import SessionDemands from './SessionDemands';
import SessionDetails from './SessionDetails';
// import SessionSpendings from './SessionSpendings';
// import SessionStats from './SessionStats';

class SessionSingle extends Component {
    state = {  
        openContract: false,
        user: {},
        DEMANDS:[],
        stats: {},
        byEmployee: {},
        index: 0,
    }
    componentDidMount = async () => {
        let res = await axios.post("/demands/session/lines/get/all", {session_id: this.props.SESSION.session_id})
        console.log('====================================');
        console.log(res.data);
        console.log('====================================');
        if (!isEmpty(res.data)){
            this.setState({DEMANDS: res.data})
            this.calcStats(res.data)
        }
    }
    calcStats = (list = this.state.DEMANDS) => {
        const { ARTICLES } = this.props;
        let stats = {
            nbEmployee: 0,
            nbArticles: 0,
            totalPrice: 0,
        }
        let byEmployee = {}
        list.map(demand => {
            stats.nbArticles += demand.demand_quantity
            stats.totalPrice += demand.demand_quantity * ARTICLES[demand.demand_article].article_price
            if (!byEmployee[demand.demand_employee]) {
                byEmployee[demand.demand_employee] = []
            }
            byEmployee[demand.demand_employee].push(demand) 
        })

        console.log('====================================');
        console.log({byEmployee});
        console.log('====================================');
        
        stats.nbEmployee = size(Object.keys(byEmployee))
        this.setState({
            stats,
            byEmployee
        })
    }
        
    handleContract = (demand, user, contract) => {
        this.setState({
            demand,
            user,
            [contract]: true
        })
    }
    handleUpdate = () => {
        this.setState({
            openUpdate: true,
        })
    }

    render() {
        const { SESSION, SESSIONS } = this.props;
        const { index, openUpdate, DEMANDS } = this.state;

        // let list = this.filterList()
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                close={this.props.close}
                maxWidth="lg"
                fullScreen
                scroll="paper"
                title={SESSIONS[SESSION.session_id].session_name}
                appBar
                secondaryAction={
                    <IconButton
                        onClick={() => this.props.handleDownload("/extract/session/demands", `Extract Demandes ${SESSIONS[SESSION.session_id].session_name}.csv`, SESSION.session_id)} disabled={this.props.downloading}
                    >
                        <DownloadRounded />
                    </IconButton>
                }
            >
                {openUpdate &&
                    <Sessions
                        update
                        session={SESSIONS[SESSION.session_id]}
                        {...this.props}
                        handleClose={() => this.setState({ openUpdate: false })}
                    />
                }
                
                <Box>
                    <SwipeableTabs
                        labels={["Infos", "Demandes"]}
                        returnIndex={(index) => this.setState({ index })}
                        tab={index}
                    >
                            <Box p={3}>
                                <SessionDetails
                                    {...this.props}
                                    {...this.state}
                                    session={SESSIONS[SESSION.session_id]}
                                    // DEMANDS={DEMANDS}
                                    />
                            </Box>
                            <Box p={3}>
                                <SessionDemands
                                    {...this.props}
                                    {...this.state}
                                    // session={SESSIONS[SESSION.session_id]}
                                />
                            </Box>
                            
                    </SwipeableTabs>
                    </Box>
            </Dialog>
        );
    }
}

export default SessionSingle;